import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import testi from '@/styles/testimonials/index.module.scss'
import Image from 'next/image'
import { TestimonialCard } from '@/components/organisms/TestimonialCard/TestimonialCard'
// import { testimonials } from '@/data/dummy/testimonials'
import { Footer } from '@/components/organisms/Footer/Footer'
import { testimonialshome } from '@/data/dummy/testimonialshome'

export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };

  const testimonialGrups = chunk(testimonialshome, 3)

  return (
    <>

      <Menu />
      <div className={testi.container}>
        <div className={testi.body_section}>
          <div className={testi.image_container}>
            <Image
              src='/img/testimonios/testimonios.png'
              className={testi.logo1}
              alt='Picture of the author '
              width={690}
              height={519}
            />
          </div>
          <div className={testi.title_container}>
            <h2 className={testi.title1}>Testimonios</h2>
            <p className={testi.text}>Entérate porque somos el sistema para administración de materiales reciclables más usado en América Latina, cientos de usuarios satisfechos lo garantizan.</p>
          </div>
        </div>
        {
             testimonialGrups.map((group, index) => (
               <div key={index} className={testi.body_section}>
                 {
                       group.map((testimonial, index) => (
                         <TestimonialCard key={index} {...testimonial} />
                       ))
                    }
               </div>
             ))
          }
      </div>
      <Footer />
    </>
  )
}
